const SECTION_REGEX = (name) =>
  new RegExp(`##\\s+${name}\\s*\\n\\s*\\\`\\\`\\\`json\\s*([\\s\\S]*?)\\\`\\\`\\\``, 'i');

const parseSection = (text, name) => {
  const match = text.match(SECTION_REGEX(name));
  if (!match) return null;
  try {
    return JSON.parse(match[1]);
  } catch (e) {
    console.warn(`Failed to parse section ${name}:`, e);
    return null;
  }
};

export const loadContentFromMarkdown = async () => {
  try {
    const res = await fetch('/content.md', { cache: 'no-cache' });
    if (!res.ok) return null;
    const text = await res.text();
    return {
      copy: parseSection(text, 'Copy'),
    };
  } catch (e) {
    console.warn('content.md load failed', e);
    return null;
  }
};
